import React from "react";
import {withRouter} from 'react-router-dom';
import styles from "./NavigationBarDesktop.module.scss";

const NavigationBarDesktop = props => {
  let pathname = props.pathname ? props.pathname.split('/') : [''];
  pathname = pathname.length > 0 ? pathname[1] : pathname[0];
  const selectedItem = props.items.find(i => {
    const url = i.url ? i.url.split('/') : [''];
    const otherUrl = i.otherUrls ? i.otherUrls.map(url => url.split('/')) : null;
    return url[1] === pathname || (otherUrl && otherUrl.find(url => url[0] === pathname));
  });

  const selectedIndex = selectedItem ? selectedItem.index : (props.default ? props.default : 0);
  const items = <ul className={`clearfix`}>
    {props.items
      .filter(i => i.display)
      .map(i => {
      let className = styles.nonSelectedItem;
      if (i.index === selectedIndex) {
        className = styles.selectedItem;
      } else if (i.index < selectedIndex) {
        className = styles.pastItem;
      }
      const label = <div className={`${className}`}>
        <div className={styles.navigationIndex}>{i.index}</div>
        <div className={styles.navigationLabel}>{i.label}</div>
      </div>;
      return <li className={styles.listItem}>
        {label}
      </li>;
    })}
  </ul>;
  const isFinal = props.final && props.final.find(fs => {
    const url = fs ? fs.split('/') : [''];
    return pathname === url[1];
  });

  return <div className={styles.menuCont}>
    <div className={`${styles.flexListDesktopCont} ${styles.desktopNavigation} ${isFinal ? styles.final : ''}`}>
      <div className={`${styles.flexListDesktop}`}>
        {items}
      </div>
    </div>
  </div>
};

export default withRouter(props => <NavigationBarDesktop {...props}/>);
